import axios from 'axios';
import auth from '@/store/auth';

export const apiUrl = (window.location.origin === 'https://dev.4kari.ru' || process.env.NODE_ENV === 'development')
  ? 'https://lk-client.bnpl.msk.finmoll.com'
  : 'https://lk-client.4kari.ru';
// export const apiUrl = (window.location.origin === 'https://dev.4kari.ru' || process.env.NODE_ENV === 'development')
//   ? 'https://lk-client.dev.4kari.ru'
//   : 'https://lk-client.4kari.ru';
/**
 *  должен обновить токен если бэк разрешить, сработает или нет хз, не могу поймать 401 ошибку
 * @returns {Promise<{errorMessage, errorCode}|*>}
 */
const refreshToken = async function () {
  const requestName = '/api/auth/refresh-token';
  const data = await runAuthRequest({
    method: 'post',
    url: `${apiUrl}${requestName}`,
    headers: {
      'x-session-id': auth.state.xSession,
      Authorization: 'Bearer ' + auth.state.accessToken
    },
    data: {
      accessToken: auth.state.accessToken,
      refreshToken: auth.state.refreshToken
    }
  }, requestName);
  if (data.accessToken !== undefined && data.refreshToken !== undefined) {
    await auth.mutations.setAuthData(auth.state, data);
    // эксперимент. Вместо 401 теперь 402
    return errObj(402, 'токены получены, возвращаем код 402');
  } else {
    return data;
  }
};
/**
 * шаблон для вывода ошибок запроса, что бы опечатками не баловались
 * @param code
 * @param msg
 * @returns {{errorMessage, errorCode}}
 */
const errObj = function (code, msg) {
  return {
    errorCode: code,
    errorMessage: msg
  };
};
/**
 * примитивная проверка, что в запросе есть нужные свойства
 * @param requestOption
 * @param requestName
 * @returns {{errorMessage, errorCode}}
 */
const checkRequestOption = function (requestOption, requestName) {
  // todo дорастить проверки объекта передаваемые в axios
  const avalaibleMethod = ['get', 'post', 'DELETE'];
  let errMsg = '';
  if (requestOption.method === undefined || avalaibleMethod.indexOf(requestOption.method) < 0) {
    errMsg = `Не указан метод запроса ${requestName}`;
    alert(errMsg);
    return errObj(100500, errMsg);
  }
  if (!requestName) {
    errMsg = 'Не указан url запроса';
    alert(errMsg);
    return errObj(111111, errMsg);
  }
  return errObj(0, '');
};
/**
 * задача отловить известные ошибки и сформировать единый ответ для принятий решений на стороне вызывающее апи
 * @param error {*} что то получаеное в try catch
 * @param requestName {string} указатель какое апи работает
 * @returns {errorMessage: string, errorCode: number} формат возврата ошибки вызывавшему запрос
 */
export const errorHandler = async function (error, requestName) {
  if (!error.response) {
    return errObj(100500, '**Network/Server error');
  }
  if (error.response?.status === 401) {
    return await refreshToken();
  }
  if (error.response.data.errorCode === 1) {
    await auth.actions.clearLocalStorageAuth;
    return errObj(error.response.data.errorCode, error.response.data.errorMessage);
  }
  if (error.response?.data?.errorCode !== undefined && error.response?.data?.errorMessage) {
    return errObj(error.response.data.errorCode, error.response.data.errorMessage);
  } else {
    return errObj(666, `По техническим причинам сервис недоступен. Попробуйте позднее. Приносим извинения за доставленные неудобства. Код ошибки:${requestName}`);
  }
};

/**
 * Запускает подготовленный запрос с требованием авторизованного пользователя, проверяет наличие ошибок возможные при взаимодействии с бэк сервисом
 * @param requestOption {{method: string,url: string, headers : {'x-session-id': string, Authorization: string}}} параметры для запуска axios запроса
 * @param countRequest {int} счетчик запуска, более двух раз запускаться не надо
 * @param requestName {string} нужен в случае когда прислали скрин "я тут нажала и все сломалось", и понять что ругнулось, если конечно указать
 * @returns {Promise<*>} что то пришло с бэк части
 */
const runAuthRequest = async function (requestOption, requestName, countRequest = 0) {
  /**
   * пихаем хедеры отдельно, дабы всегда был свежий токен
   * @type {{Authorization: string, 'x-session-id': string | string}}
   */
  requestOption.headers = {
    'x-session-id': auth.state.xSession,
    Authorization: 'Bearer ' + auth.state.accessToken
  }
  countRequest += 1;
  if (countRequest > 10) {
    return errObj(500, `По техническим причинам сервис недоступен. Попробуйте позднее. Код ошибки:${requestName}req`);
  }
  const check = checkRequestOption(requestOption, requestName);
  if (check.errorCode !== 0) {
    return check;
  }
  try {
    const { data } = await axios(requestOption);
    return data;
  } catch (error) {
    const errorDesign = await errorHandler(error, requestName);
    if (errorDesign.errorCode === 402) {
      // если токен обновился, то еще раз пробуем выполнить запрос к данным
      return await runAuthRequest(requestOption, requestName, countRequest);
    } else {
      return errorDesign;
    }
  }
};
/**
 * запрос получает от бэк информацию по рассрочкам клиента
 * @returns {Promise<*>}
 */
export const getOrders = async function () {
  const requestName = '/api/orders';
  return await runAuthRequest({
    method: 'get',
    url: `${apiUrl}${requestName}`
  }, requestName);
};

export const getOrderDetails = async function (orderIndetificator) {
  // console.log('запрос на получение детализации по рассрочке')
  const requestName = '/api/orders';
  return await runAuthRequest({
    method: 'get',
    url: `${apiUrl}${requestName}/${orderIndetificator}`
  }, requestName);
};

export const getDocument = async function (orderIndetificator, path) {
  return await runAuthRequest({
    method: 'get',
    responseType: 'blob',
    url: `${apiUrl}${path}${orderIndetificator}`
  }, path);
};
/**
 * авторизация на сайте
 * @param data логин и пароль
 */
export const letMeIn = async function (data) {
  if (data) {
    const currentTime = new Date();
    localStorage.setItem('accessTokenCreateTime', currentTime.getTime());
    const requestName = '/api/auth/login';
    return await runAuthRequest({
      method: 'post',
      url: `${apiUrl}${requestName}`,
      data: data
    }, requestName);
  }
};
/**
 * получение данных пользователя
 */
export const getUserData = async function () {
  const requestName = '/api/profile';
  return await runAuthRequest({
    method: 'get',
    url: `${apiUrl}${requestName}`
  }, requestName)
};
/**
 * получение данных пользователя
 */
export const getUserCards = async function () {
  const requestName = '/api/card';
  return await runAuthRequest({
    method: 'get',
    url: `${apiUrl}${requestName}`
  }, requestName);
};
/**
 * прикрепление новой карты
 */
export const attachNewCard = async function () {
  const requestName = '/api/card';
  return await runAuthRequest({
    method: 'post',
    url: `${apiUrl}${requestName}`
  }, requestName);
};
/**
 * сделать карту дефолтной
 */
export const selectCardAsDefault = async function (cardId) {
  const requestName = '/api/card/' + cardId + '/make-default';
  return await runAuthRequest({
    method: 'post',
    url: `${apiUrl}${requestName}`
  }, requestName);
};
/**
 * удалить карту
 */
export const removeSelectedCard = async function (cardId) {
  const requestName = '/api/card/' + cardId;
  return await runAuthRequest({
    method: 'DELETE',
    url: `${apiUrl}${requestName}`
  }, requestName);
};
/**
 * оплата по графику
 * @param data - объект, включающий в себя гуид заказа и сумму к оплате
 */
export const payMe = async function (data) {
  const requestName = '/api/card/charge-sequentially';
  return await runAuthRequest({
    method: 'post',
    data: data,
    url: `${apiUrl}${requestName}`
  }, requestName)
};
/**
 * оплата досрочно конкретной картой
 * @param data - объект, включающий в себя гуид заказа, сумма к оплате и выбранную карту банка
 */
export const payAheadWithCard = async function (data) {
  const requestName = '/api/card/' + data.id + '/charge';
  return await runAuthRequest({
    method: 'post',
    data: data,
    url: `${apiUrl}${requestName}`
  }, requestName)
};
/**
 * сохранение нового пароля
 * @param pass - новый пароль
 */
export const submitNewPassRequest = async function (pass) {
  const requestName = '/api/auth/change-password';
  return await runAuthRequest({
    method: 'post',
    data: {
      login: auth.state.login,
      newPassword: pass
    },
    url: `${apiUrl}${requestName}`
  }, requestName)
};
/**
 * проверка кода из смс на вшивость
 * @param code код из смс
 */
export const checkMySms = async function (code) {
  const requestName = '/api/auth/approve-code';
  return await runAuthRequest({
    method: 'post',
    data: {
      login: auth.state.login,
      code: code
    },
    url: `${apiUrl}${requestName}`
  }, requestName)
};
/**
 * запрос на получение смс с кодом для восстановления пароля
 * @returns {Promise<*>}
 */
export const giveMeSms = async function () {
  const requestName = '/api/auth/recovery';
  return await runAuthRequest({
    method: 'post',
    data: {
      login: auth.state.login
    },
    url: `${apiUrl}${requestName}`
  }, requestName)
};
/**
 * разлогин
 * @returns {Promise<*>}
 */
export const logOut = async function () {
  const requestName = '/api/auth/logout';
  const data = {
    accessToken: auth.state.accessToken,
    refreshToken: auth.state.refreshToken
  };
  return await runAuthRequest({
    method: 'post',
    data: data,
    url: `${apiUrl}${requestName}`
  }, requestName)
};
